/**
 * Computes the smart default snooze time based on current time and day.
 * Friday after noon → Monday 9 AM. Weekday after 3 PM → next day 9 AM.
 * Weekday before 3 PM → today at 5 PM.
 */
export function defaultSnoozeTime(): Date {
  const now = new Date();
  const hour = now.getHours();
  const day = now.getDay(); // 0=Sun, 6=Sat

  const result = new Date(now);

  // Weekend → Monday 9 AM
  if (day === 0 || day === 6) {
    const daysUntilMon = day === 0 ? 1 : 2;
    result.setDate(result.getDate() + daysUntilMon);
    result.setHours(9, 0, 0, 0);
    return result;
  }
  // Friday after noon → Monday 9 AM
  if (day === 5 && hour >= 12) {
    result.setDate(result.getDate() + 3);
    result.setHours(9, 0, 0, 0);
    return result;
  }
  // Weekday after 3 PM → next business day 9 AM
  if (hour >= 15) {
    const daysAhead = day === 5 ? 3 : 1;
    result.setDate(result.getDate() + daysAhead);
    result.setHours(9, 0, 0, 0);
    return result;
  }
  // Weekday before 3 PM → today 5 PM
  result.setHours(17, 0, 0, 0);
  return result;
}

export const SNOOZE_OPTIONS = [
  { label: '1 hour',        getTime: () => { const d = new Date(); d.setHours(d.getHours() + 1); return d; } },
  { label: '4 hours',       getTime: () => { const d = new Date(); d.setHours(d.getHours() + 4); return d; } },
  { label: 'End of day',    getTime: () => { const d = new Date(); d.setHours(17, 0, 0, 0); return d; } },
  { label: 'Tomorrow 9 AM', getTime: () => { const d = new Date(); d.setDate(d.getDate() + 1); d.setHours(9, 0, 0, 0); return d; } },
  { label: 'Monday 9 AM',   getTime: () => {
    const d = new Date();
    const daysUntilMon = (8 - d.getDay()) % 7 || 7;
    d.setDate(d.getDate() + daysUntilMon);
    d.setHours(9, 0, 0, 0);
    return d;
  }},
];

/** Format a snooze time for display: "Today 5:00 PM", "Mon Aug 11 9:00 AM" */
export function formatSnoozeTime(d: Date): string {
  const now = new Date();
  const isToday = d.toDateString() === now.toDateString();
  const isTomorrow = d.toDateString() === new Date(now.getTime() + 86400000).toDateString();
  const time = d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  if (isToday)    return `Today ${time}`;
  if (isTomorrow) return `Tomorrow ${time}`;
  return d.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' }) + ` ${time}`;
}
